// eslint-disable-next-line no-unused-vars
const prod = 'https://api.letoh.co/api';
const local = 'http://127.0.0.1:8000/api';

const API_BASE_URL = prod;

export default API_BASE_URL;